// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NewsletterBreaker_wrapper__PPl4c","article":"NewsletterBreaker_article__b0Ztt"};